var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Cursor.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Cursor = ({
  color = '#5F668F',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "23",
  height: "35",
  viewBox: "0 0 23 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    width: "20",
    height: "30",
    transform: "translate(2 1)",
    fill: "white",
    fillOpacity: "0.01"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_d_2004_228316)",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.2283 31.11L15.3333 29.4383L18.025 28.04L13.745 20.0133H20.965L2 1V27.6917L7.52667 22.3233L12.2283 31.11Z",
      fill: "white"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7007 28.6547L15.6424 27.0864L11.0185 18.417H17.0244L3.64941 5.01202V23.6587L7.86581 19.5885L12.7007 28.6547Z",
    fill: color
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsxs("filter", {
      id: "filter0_d_2004_228316",
      x: "0",
      y: "0",
      width: "22.9648",
      height: "34.11",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "1"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "1"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2004_228316"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_2004_228316",
        result: "shape"
      })]
    })
  })]
});